<template>
	<h1 class="text-center">
		Merci, vous avez complété le questionnaire Otelico
	</h1>
</template>

<script>
export default {};
</script>